// Kyrgyz translations
export const ky: Record<string, string> = {
  'menu.dashboard': 'Башкаруу панели',
  'menu.customers': 'Кардарлар',
  'menu.products': 'Өнүмдөр',
  'menu.users': 'Колдонуучулар',
  'menu.settings': 'Жөндөөлөр',
  'menu.logout': 'Чыгуу',
  'dashboard.title': 'Башкаруу панели',
  'dashboard.newOrder': 'Жаңы заказ',
  'order.title': 'Жаңы заказ',
  'order.customer': 'Кардар',
  'order.products': 'Өнүмдөр',
  'order.total': 'Жыйынтык',
  'users.title': 'Колдонуучулар',
  'users.name': 'Аты',
  'users.email': 'Электрондук почта',
  'common.yes': 'Ооба',
  'common.no': 'Жок',
  'common.cancel': 'Жокко чыгаруу',
  'common.save': 'Сактоо',
  'common.search': 'Издөө',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Кирүү',
  'login.welcome': 'Кош келиңиз, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Электрондук почта',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Отчеттор жана бухгалтерия',
  'menu.systemAndCommunication': 'Система жана байланыш',
};